// @generated by protoc-gen-connect-query v1.4.1 with parameter "target=ts"
// @generated from file no/jotta/openapi/signup/v1/signup.v1.proto (package no.jotta.openapi.signup.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { MethodKind } from "@bufbuild/protobuf";
import { BusinessSignupRequest, BusinessSignupResponse, CheckEmailRequest, CheckEmailResponse, CheckNameRequest, CheckNameResponse, CheckPhoneNumberRequest, CheckPhoneNumberResponse, DescribeVoucherRequest, DescribeVoucherResponse, SignupRequest, SignupResponse, VerifyPreSignupRequest, VerifyPreSignupResponse } from "./signup.v1_pb.js";
import { PingRequest, PingResponse } from "../../ping_pb.js";
/**
 * @generated from rpc no.jotta.openapi.signup.v1.SignupService.Signup
 */
export const signup = {
    localName: "signup",
    name: "Signup",
    kind: MethodKind.Unary,
    I: SignupRequest,
    O: SignupResponse,
    service: {
        typeName: "no.jotta.openapi.signup.v1.SignupService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.signup.v1.SignupService.BusinessSignup
 */
export const businessSignup = {
    localName: "businessSignup",
    name: "BusinessSignup",
    kind: MethodKind.Unary,
    I: BusinessSignupRequest,
    O: BusinessSignupResponse,
    service: {
        typeName: "no.jotta.openapi.signup.v1.SignupService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.signup.v1.SignupService.CheckEmail
 */
export const checkEmail = {
    localName: "checkEmail",
    name: "CheckEmail",
    kind: MethodKind.Unary,
    I: CheckEmailRequest,
    O: CheckEmailResponse,
    service: {
        typeName: "no.jotta.openapi.signup.v1.SignupService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.signup.v1.SignupService.CheckName
 */
export const checkName = {
    localName: "checkName",
    name: "CheckName",
    kind: MethodKind.Unary,
    I: CheckNameRequest,
    O: CheckNameResponse,
    service: {
        typeName: "no.jotta.openapi.signup.v1.SignupService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.signup.v1.SignupService.CheckPhoneNumber
 */
export const checkPhoneNumber = {
    localName: "checkPhoneNumber",
    name: "CheckPhoneNumber",
    kind: MethodKind.Unary,
    I: CheckPhoneNumberRequest,
    O: CheckPhoneNumberResponse,
    service: {
        typeName: "no.jotta.openapi.signup.v1.SignupService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.signup.v1.SignupService.DescribeVoucher
 */
export const describeVoucher = {
    localName: "describeVoucher",
    name: "DescribeVoucher",
    kind: MethodKind.Unary,
    I: DescribeVoucherRequest,
    O: DescribeVoucherResponse,
    service: {
        typeName: "no.jotta.openapi.signup.v1.SignupService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.signup.v1.SignupService.VerifyPreSignup
 */
export const verifyPreSignup = {
    localName: "verifyPreSignup",
    name: "VerifyPreSignup",
    kind: MethodKind.Unary,
    I: VerifyPreSignupRequest,
    O: VerifyPreSignupResponse,
    service: {
        typeName: "no.jotta.openapi.signup.v1.SignupService"
    }
};
/**
 * Safe noop for testing purposes
 *
 * @generated from rpc no.jotta.openapi.signup.v1.SignupService.Ping
 */
export const ping = {
    localName: "ping",
    name: "Ping",
    kind: MethodKind.Unary,
    I: PingRequest,
    O: PingResponse,
    service: {
        typeName: "no.jotta.openapi.signup.v1.SignupService"
    }
};
